import { useDropzone, type DropEvent, type FileRejection } from "react-dropzone";

export interface UploadAreaProps {
  icon: React.ReactNode;
  description: string;
  fileHint: string;
  onDrop: (
    acceptedFiles: File[],
    fileRejections: FileRejection[],
    event: DropEvent,
  ) => void;
  accept?: Record<string, string[]>;
}

export const UploadArea = ({
  icon,
  description,
  fileHint,
  onDrop,
  accept,
}: UploadAreaProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
  });

  return (
    <div
      {...getRootProps()}
      className={`h-full border-2 border-dashed rounded-lg flex-1 text-center transition-colors cursor-pointer flex flex-col items-center justify-center ${
        isDragActive
          ? "border-primary bg-primary/5"
          : "border-muted-foreground/25 hover:border-muted-foreground/50"
      }`}
    >
      <input {...getInputProps()} className="hidden" />
      {icon}
      <p className="text-sm font-medium mb-1">
        {isDragActive ? "松开以上传文件" : description}
      </p>
      <p className="text-xs text-muted-foreground mb-2">{fileHint}</p>
      <p className="text-xs text-muted-foreground">或点击选择文件</p>
    </div>
  );
};
